// extracted by mini-css-extract-plugin
export var baseTextAltGlobal = "text-grid-module--base-text-alt--global--ccecb";
export var baseTextGlobal = "text-grid-module--base-text--global--c995f";
export var blockSpacing100 = "text-grid-module--block-spacing-100--4e598";
export var blockSpacing50 = "text-grid-module--block-spacing-50--9dd0c";
export var blockVPadding100 = "text-grid-module--block-v-padding-100--7c30b";
export var blockVPadding50 = "text-grid-module--block-v-padding-50--4c3e6";
export var body = "text-grid-module--body--1b0fd";
export var captionTextGlobal = "text-grid-module--caption-text--global--b78da";
export var cmsRenderedContentGlobal = "text-grid-module--cms-rendered-content--global--2f754";
export var colCount2 = "text-grid-module--colCount2--c776c";
export var colCount3 = "text-grid-module--colCount3--b2173";
export var container = "text-grid-module--container--3394b";
export var contentContainer = "text-grid-module--contentContainer--71e3c";
export var defaultHSpacingGlobal = "text-grid-module--default-h-spacing--global--95a1c";
export var fadeInAnimation = "text-grid-module--fadeInAnimation--5b8de";
export var fadeInOnLoadGlobal = "text-grid-module--fade-in-on-load--global--0c2ce";
export var fullHeightGlobal = "text-grid-module--full-height--global--7fd5d";
export var fullHeightOmittingNavGlobal = "text-grid-module--full-height-omitting-nav--global--3bbc6";
export var heading = "text-grid-module--heading--e0834";
export var headingTextGlobal = "text-grid-module--heading-text--global--82045";
export var image = "text-grid-module--image--f9d6d";
export var imageContainer = "text-grid-module--imageContainer--162cb";
export var ingressTextGlobal = "text-grid-module--ingress-text--global--f6d67";
export var link = "text-grid-module--link--cdc99";
export var linkColorChangeTransitionGlobal = "text-grid-module--link-color-change-transition--global--4da62";
export var mobileNavBarHeight = "85px";
export var pageHeadingTextGlobal = "text-grid-module--page-heading-text--global--e164c";
export var paragraphTextGlobal = "text-grid-module--paragraph-text--global--31f23";
export var subheadingTextGlobal = "text-grid-module--subheading-text--global--e13e2";
export var textsContainer = "text-grid-module--textsContainer--de3d0";
export var title = "text-grid-module--title--2c7d5";
export var videoContainer = "text-grid-module--videoContainer--56c44";